import { cva } from 'class-variance-authority';

import s from './Stack.module.css';

export const stackVariants = cva(s.layer1, {
  defaultVariants: {
    variant: 'default',
  },
  variants: {
    variant: {
      accent: s['layer1--accent'],
      alt: s['layer1--alt'],
      danger: s['layer1--danger'],
      default: s['layer1--default'],
      success: s['layer1--success'],
    },
  },
});
